import React from 'react';
import { useFormikContext } from 'formik';

import Modal from '~/commons/components/Modal.jsx';

const ModalAnsConfirm = ({
  timeLeft,
  show,
  onReject = () => {},
  onConfirm = () => {},
  doublePoint,
  haveChallenge,
}) => {
  const { values } = useFormikContext();

  const completed = values.answers.find((a) => {
    if (a.format == 'single-select') {
      return a.answered === undefined;
    }
    if (a.format == 'multi-select') {
      return a.answeredSeq.length === 0;
    }
    if (a.format == 'ordering' || a.format == 'matching') {
      return a.answeredSeq.find((a) => a === undefined);
    }
  });

  return (
    <Modal show={show} onHide={onReject} centered>
      <div className="text-center p-4">
        {completed ? (
          <>
            <h5 className="text-danger">你尚未完成，請返回上頁。</h5>
            <button
              onClick={onReject}
              className="m-2 btn btn-primary btn-fixed-w"
            >
              返回
            </button>
          </>
        ) : (
          <>
            {doublePoint && haveChallenge && (
              <h5>{`你已選擇第${doublePoint.quesationNum}題使用王牌雙倍分`}</h5>
            )}
            {!doublePoint && haveChallenge && (
              <h5>
                你尚未使用王牌雙倍分功能，
                你可以選擇至多一條挑戰題使用王牌雙倍分。
              </h5>
            )}
            <h5>你的答案只可以提交一次，確定提交答案？</h5>
            <h5>
              餘下時間還有<span className="text-danger">{timeLeft}</span>。
            </h5>
            <div className="mt-4">
              <button
                onClick={onReject}
                className="m-2 btn btn-primary btn-fixed-w"
              >
                取消
              </button>
              <button
                onClick={onConfirm}
                className="m-2 btn btn-outline-primary btn-fixed-w"
              >
                確定提交答案
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ModalAnsConfirm;
